import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-followup-bulk-upload',
  templateUrl: './followup-bulk-upload.component.html',
  styleUrls: ['./followup-bulk-upload.component.css']
})
export class FollowupBulkUploadComponent implements OnInit {
  login_Details: any;
  bulkUploadLoader = false;
  bulkExcelRows: any[] = [];
  bulkUploadResult: any = null;

  followupBulkHeaders = [
    'acc_no',
    'passport_no',
    'log_type',
    'mstatus',
    'substatus',
    'remarks',
    'fdate',
    'bcode',
    'actiontaken',
    'actiontotake',
    'ptp_amount',
    'ptp_date',
    'labour_card',
    'ded_number',
    'mol_status',
    'ded_status',
    'uid_status',
    'uid_number',
    'territory',
    'fvarea',
    'request_type',
    'no_mapped_account',
    'tracingtool'
  ];

  constructor(
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) {}

  ngOnInit(): void {
    this.login_Details = this.storage.get('login_Details');
    window.scrollTo(0, 0);
  }

  private dateColumns = ['fdate', 'ptp_date'];

  private normalizeExcelValue(value: any, isDate = false): string {
    if (value === undefined || value === null) return '';
    if (typeof value === 'number') {
      if (isDate && value > 20000 && value < 60000) {
        const date = new Date(Math.round((value - 25569) * 86400 * 1000));
        if (!isNaN(date.getTime())) {
          return date.toISOString().slice(0, 10);
        }
      }
      return String(value);
    }
    return String(value).trim();
  }

  downloadFollowupExcelTemplate() {
    const sampleRow: any = {};
    this.followupBulkHeaders.forEach((h) => (sampleRow[h] = ''));
    sampleRow.acc_no = '244463';
    sampleRow.passport_no = '';
    sampleRow.log_type = 'CALL';
    sampleRow.mstatus = 'PTP';
    sampleRow.substatus = 'Promised';
    sampleRow.remarks = 'Sample remark - replace with actual data';
    sampleRow.fdate = moment().format('YYYY-MM-DD');
    sampleRow.bcode = 'QNB';
    sampleRow.actiontaken = 'Called';
    sampleRow.actiontotake = 'Follow Up';
    sampleRow.ptp_amount = '1500';
    sampleRow.ptp_date = moment().add(7, 'days').format('YYYY-MM-DD');

    const ws = XLSX.utils.json_to_sheet([sampleRow], { header: this.followupBulkHeaders });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'FollowUp_Bulk');
    XLSX.writeFile(wb, 'followup_bulk_upload_template.xlsx');
  }

  onBulkExcelSelected(event: any) {
    this.bulkUploadResult = null;
    this.bulkExcelRows = [];
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const jsonRows = XLSX.utils.sheet_to_json(ws, { defval: '' });
        this.bulkExcelRows = (jsonRows || []).map((row: any) => {
          const mapped: any = {};
          this.followupBulkHeaders.forEach((key) => {
            mapped[key] = this.normalizeExcelValue(row[key], this.dateColumns.includes(key));
          });
          return mapped;
        });
        if (!this.bulkExcelRows.length) {
          alert('No rows found in excel. Please use the download template format.');
        }
      } catch (err) {
        console.error(err);
        alert('Unable to read excel file. Please use .xlsx template format.');
        this.bulkExcelRows = [];
      }
    };
    reader.readAsBinaryString(file);
    event.target.value = '';
  }

  uploadBulkFollowupExcel() {
    if (!this.login_Details || !this.login_Details._id) {
      alert('Login details not found. Please login again.');
      return;
    }
    if (!this.bulkExcelRows.length) {
      alert('Please select a valid excel file first');
      return;
    }

    this.bulkUploadLoader = true;
    const payload = {
      createdby: this.login_Details._id,
      creator_name: this.login_Details.name,
      followups: this.bulkExcelRows
    };

    this._api.bulk_create_new_FollowUp(payload).subscribe(
      (data: any) => {
        this.bulkUploadLoader = false;
        if (data && data.Code == 200) {
          this.bulkUploadResult = data.Data;
          Swal.fire({
            icon: 'success',
            title: 'Bulk Upload Done',
            text: data.Message
          });
        } else {
          alert((data && data.Message) || 'Bulk upload failed');
        }
      },
      () => {
        this.bulkUploadLoader = false;
        alert('Bulk upload failed');
      }
    );
  }
}
